import includes from 'lodash/includes';
import isNull from 'lodash/isNull';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {
    Route,
    Switch
} from 'react-router-dom';
import Checkout from 'checkout/Checkout';
import Home from 'home/Home';
import SearchAirport from 'search/airport/SearchAirport';
import SpotDetailsAirport from 'spot-details/airport/SpotDetailsAirport';
import SearchDesktop from 'search/SearchDesktop';
import SearchMobile from 'search/SearchMobile';
import NotFound from './NotFound';
import WithConfig from 'config/WithConfig';

class AppRouter extends Component {
    static propTypes = {
        isMobile: PropTypes.bool,
        citySlugs: PropTypes.arrayOf(PropTypes.string).isRequired,
        pageType: PropTypes.string,
        isMonthly: PropTypes.bool.isRequired,
        destination: PropTypes.object
    };

    _handleRoute = ({match}) => {
        const {
            isMobile,
            citySlugs,
            pageType,
            isMonthly,
            destination
        } = this.props;
        const {
            params: {
                page,
                section
            }
        } = match;
        const isCheckout = includes(page, '-parking') && section && !includes(page, '-monthly-parking');
        let CurrentRouteComponent = null;

        if (isNull(pageType)) { return null; }

        if (!isCheckout
            && ((!section && includes(citySlugs, page))
            || page === 'search'
            || includes(page, 'parking-near-me')
            || includes(section, 'parking-near-me')
            || (includes(page, '-parking') && !section)
            || (!includes(page, '-parking') && includes(section, '-parking'))
            || includes(page, '-monthly-parking'))) {
            // search url
            CurrentRouteComponent = (isMobile)
                ? SearchMobile
                : SearchDesktop;

            if (destination.airport && !isMonthly) {
                CurrentRouteComponent = SearchAirport;
            }
        } else if (isCheckout) {
            // TODO: This is only here because we still have to support old checkout routing before we move to the full new
            // routing setup, eventually the route will only happen below in the Switch.
            CurrentRouteComponent = Checkout;
        } else {
            CurrentRouteComponent = NotFound;
        }

        return <CurrentRouteComponent />;
    }

    render() {
        return (
            <Switch>
                <Route
                    exact
                    path="/"
                    component={Home}
                />
                <Route
                    path="/checkout/:spotId/:facilitySlug"
                    component={Checkout}
                />
                <Route
                    path="/airport-parking/:spotId/:facilitySlug"
                    component={SpotDetailsAirport}
                />
                <Route
                    path="/:page/:section?"
                    component={this._handleRoute}
                />
            </Switch>
        );
    }
}

export default WithConfig(AppRouter);
